// ** React Imports
import {Fragment, useEffect, useState} from 'react'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Third Party Components
import classnames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {Bell, X, Check, AlertTriangle, Info} from 'react-feather'
import {
    Button,
    Badge,
    Media,
    CustomInput,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    UncontrolledDropdown
} from 'reactstrap'
import {getUserData} from "../../../../auth/utils";
import axios from "axios";

const NotificationDropdown = () => {

    const [notifications, setNotifications] = useState([]);
    const [notificationsFetched, setNotificationsFetched] = useState(false);

    let getNumberOfUnread = () => {
        let number = 0;
        notifications.map((oneNotification) => {
            if (!oneNotification.read) {
                number++;
            }
        })

        return number
    }

    function refreshNotifications() {
        axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/get-user?userId=${getUserData().userData._id}`).then((result) => {
            if (result.data.user != null) {
                let notifications = result.data.user.notifications;
                setNotifications(notifications)
            }
        })
    }

    useEffect(() => {
        if (getUserData() && getUserData().userData && !notificationsFetched) {
            setNotificationsFetched(true)
            let notifications = getUserData().userData.notifications;
            setNotifications(notifications)
        }
    })


    // ** Notification Array
    const notificationsArray = []

    notifications.map((oneNotification) => {
        notificationsArray.push(
            {
                avatarIcon: <Info size={14}/>,
                color: 'light-info',
                title: (
                    <Media tag='p' heading>
                        <span className='font-weight-bolder'>{oneNotification.name} - {oneNotification.info}</span>&nbsp;
                    </Media>
                )
            }
        )
    })


    // ** Function to render Notifications
    /*eslint-disable */
    const renderNotificationItems = () => {
        return (
            <PerfectScrollbar
                component='li'
                className='media-list scrollable-container'
                options={{
                    wheelPropagation: false
                }}
            >
                {notificationsArray.map((item, index) => {
                    return (
                        <a key={index} className='d-flex' href='/' onClick={e => e.preventDefault()}>
                            <Media
                                className={classnames('d-flex', {
                                    'align-items-start': !item.switch,
                                    'align-items-center': item.switch
                                })}
                            >
                                {!item.switch ? (
                                    <Fragment>
                                        <Media left>
                                            <Avatar
                                                {...(item.img
                                                    ? {img: item.img, imgHeight: 32, imgWidth: 32}
                                                    : item.avatarContent
                                                        ? {
                                                            content: item.avatarContent,
                                                            color: item.color
                                                        }
                                                        : item.avatarIcon
                                                            ? {
                                                                icon: item.avatarIcon,
                                                                color: item.color
                                                            }
                                                            : null)}
                                            />
                                        </Media>
                                        <Media body>
                                            {item.title}
                                            <small className='notification-text'>{item.subtitle}</small>
                                        </Media>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        {item.title}
                                        {item.switch}
                                    </Fragment>
                                )}
                            </Media>
                        </a>
                    )
                })}
            </PerfectScrollbar>
        )
    }
    /*eslint-enable */

    return (
        <UncontrolledDropdown tag='li' className='dropdown-notification nav-item mr-25'>
            <DropdownToggle tag='a' id={"dropdown-toggle-item"} className='nav-link' href='/'
                            onClick={e => e.preventDefault()}>
                <Bell size={21}/>
                {getNumberOfUnread() != 0 &&
                <Badge pill color='danger' className='badge-up'>
                    {getNumberOfUnread()}
                </Badge>
                }
            </DropdownToggle>
            <DropdownMenu tag='ul' right className='dropdown-menu-media mt-0'>
                <li className='dropdown-menu-header'>
                    <DropdownItem className='d-flex' tag='div' header>
                        <h4 className='notification-title mb-0 mr-auto'>Notifications</h4>
                        <Badge tag='div' color='light-primary' pill>
                            {getNumberOfUnread()} New
                        </Badge>
                    </DropdownItem>
                </li>
                {renderNotificationItems()}
                {getNumberOfUnread() != 0 &&
                <li className='dropdown-menu-footer'>
                    <Button.Ripple onClick={() => {
                        axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/read-notifications?userId=` + getUserData().userData._id).then((result) => {
                            refreshNotifications();
                        })
                        document.getElementById("dropdown-toggle-item").click();
                    }} color='primary' block>
                        Označi sve kao pročitano
                    </Button.Ripple>
                </li>
                }
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default NotificationDropdown
